module.exports = __webpack_public_path__ + "static/img/transaction_close.f6fd553.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/transaction_close.png
// module id = vNEX
// module chunks = 0